export const TYPE_BORDEREAU = {
	DEPENSE: {
		ORDINAIRE: '01',
		ANNUL_REDUC: '02',
		ORDRE_PAIE: '03',
	},
	RECETTE: {
		ORDINAIRE: '01',
		ANNUL_REDUC: '02',
		ORDRE_RECETTE: '03',
		ORDRE_RECETTE_MULTI_CREANCIERS: '06',
	},
	REJET: 'RE',
} as const;

/**
 * Bordereaux d'annulation (02, même code en recette) ou de rejet (RE) : leurs pièces en annulent déjà une autre, ils
 * ne s'annulent ni ne se rejettent eux-mêmes.
 */
export const TYPES_BORDEREAU_ANNULATION: readonly string[] = [
	TYPE_BORDEREAU.DEPENSE.ANNUL_REDUC,
	TYPE_BORDEREAU.REJET,
];

export const TYPE_BORDEREAU_NAT_TYP_PCE_DEPENSE = {
	'01': {
		'01': ['01', '03', '04', '05', '06', '07', '08', '09', '10', '13'],
		'02': ['01', '03', '04', '05', '08', '09', '10'],
		'03': ['01', '03', '04', '05', '10'],
		'04': ['01', '03', '04', '05', '06', '10'],
		'05': ['01', '05', '10'],
		'07': ['02', '06'],
		'08': ['02'],
		'09': ['02'],
		11: ['01', '08', '10'],
		12: ['09'],
		13: ['09'],
		14: ['09'],
		18: ['03'],
	},
	'02': {
		'06': ['02', '04', '13'],
		10: ['02'],
	},
	RE: {
		'06': ['02'],
	},
};

export const TYPE_BORDEREAU_NAT_TYP_PCE_RECETTE = {
	'01': {
		'01': ['01', '03', '04', '05', '06', '07', '09', '10', '11', '14'],
		'02': ['01', '03', '04', '05', '10', '11'],
		'03': ['01', '03', '04', '05'],
		'04': ['01', '03', '04', '05', '11'],
		'05': ['01', '05'],
		'07': ['02'],
		'08': ['02'],
		'09': ['02'],
		11: ['01'],
		18: ['01', '03'],
	},
	'02': {
		'06': ['02', '04', '06', '14'],
		10: ['02'],
	},
	RE: {
		'06': ['02'],
	},
};
